const updateAnnouncementSliderTabindex = () => {
    document.querySelectorAll('.announcement-slider__slide[aria-hidden="true"]').forEach(slide => {
        slide.querySelectorAll('a, button, input, select, textarea').forEach(focusable => {
            focusable.setAttribute('tabindex', '-1');
        });
    });
    document.querySelectorAll('.announcement-slider__slide[aria-hidden="false"], .announcement-slider__slide.is-selected:not([aria-hidden="true"])').forEach(slide => {
        slide.querySelectorAll('[tabindex="-1"]').forEach(focusable => {
            focusable.removeAttribute('tabindex');
        });
    });
};

new MutationObserver((mutations) => {
    document.querySelectorAll('span[role="button"]').forEach(el => {
        el.removeAttribute('role')
    });
    mutations.forEach(mutation => {
        if (mutation.target.classList && mutation.target.classList.contains('announcement-slider__slide')) {
            updateAnnouncementSliderTabindex();
        }
    });
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });

updateAnnouncementSliderTabindex();

document.querySelectorAll('span[role="button"]').forEach(el => {
    el.removeAttribute('role');
    el.removeAttribute('tabindex');
})

new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

fixAccessibility();